export const SITE_ACQUISITION_CARD_FRENCH_LOCALE = {
  title: "Acquisition",
  subtitle: "7 derniers jours",
  state: {
    BAD: "Mauvais",
    MEDIUM: "Moyen",
    GOOD: "Bon",
  },
};
